import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { debounce } from 'lodash-es';
import { useService } from '@kaokei/use-vue-service';
import { UserService } from '@/services/user.service';
import { LoginService } from '@/services/login.service';
import { useRouter, useRoute } from 'vue-router';
import { initZhiChi, SHOW_BRAND } from '@/utils';
export default defineComponent({
  name: 'FixedButtonGroup',
  setup: function () {
    var router = useRouter();
    var route = useRoute();
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var visible = ref(false);
    var updateVisible = function () {
      var stop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      visible.value = stop > 100;
    };
    var updateVisibleDebounce = debounce(updateVisible, 500);
    onMounted(function () {
      updateVisible();
      window.addEventListener('scroll', updateVisibleDebounce, false);
    });
    onUnmounted(function () {
      window.removeEventListener('scroll', updateVisibleDebounce, false);
    });
    var goToTop = function () {
      window.scrollTo(0, 0);
    };
    var goToEnvCheck = function () {
      var _a;
      if (userService.user) {
        var newQuery = ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query;
        router.push({
          name: 'UserEnvCheck',
          query: newQuery
        });
      } else {
        loginService.showLoginDialog();
      }
    };
    var initZhiChiFirstTime = function () {
      initZhiChi();
    };
    return {
      visible: visible,
      goToTop: goToTop,
      goToEnvCheck: goToEnvCheck,
      initZhiChiFirstTime: initZhiChiFirstTime,
      SHOW_BRAND: SHOW_BRAND
    };
  }
});